import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { SSLogoIcon } from './SSLogo';
import { Globe, Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

export default function Footer() {
  const { isRTL } = useLanguage();

  return (
    <footer className="bg-[hsl(222,18%,5%)] border-t border-border mt-16">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4" dir="ltr">
              <SSLogoIcon size={32} />
              <div>
                <span className="font-heading text-sm font-bold text-foreground">SHOP & SHIP</span>
                <p className="text-[8px] text-muted-foreground tracking-[2px]">SELL · EARN · GROW</p>
              </div>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed mb-4">
              {isRTL ? 'منصة التجارة الإلكترونية الرائدة. بع منتجات واكسب عمولات بدون مخزون. نحن نخزن ونشحن — أنت فقط تبيع!' : 'Leading e-commerce platform. Sell products and earn commissions without inventory. We store & ship — you just sell!'}
            </p>
            <div className="flex gap-3">
              {[Facebook, Instagram, Twitter].map((Icon, i) => (
                <a key={i} href="#" className="w-8 h-8 rounded-lg bg-muted/50 flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground mb-4">{isRTL ? 'روابط سريعة' : 'Quick Links'}</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/products', label: isRTL ? 'المنتجات' : 'Products' },
                { to: '/buy-coins', label: isRTL ? 'شراء كوينز' : 'Buy Coins' },
                { to: '/tutorials', label: isRTL ? 'الدروس' : 'Tutorials' },
                { to: '/about', label: isRTL ? 'من نحن' : 'About Us' },
              ].map((link, i) => (
                <li key={i}><Link to={link.to} className="text-xs text-muted-foreground hover:text-primary transition-colors">{link.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground mb-4">{isRTL ? 'قانوني' : 'Legal'}</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/privacy', label: isRTL ? 'سياسة الخصوصية' : 'Privacy Policy' },
                { to: '/terms', label: isRTL ? 'الشروط والأحكام' : 'Terms & Conditions' },
                { to: '/support', label: isRTL ? 'الدعم' : 'Support' },
              ].map((link, i) => (
                <li key={i}><Link to={link.to} className="text-xs text-muted-foreground hover:text-primary transition-colors">{link.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground mb-4">{isRTL ? 'تواصل معنا' : 'Contact Us'}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-xs text-muted-foreground"><Mail className="w-3.5 h-3.5 text-primary" /> support@shopandship.com</li>
              <li className="flex items-center gap-2 text-xs text-muted-foreground"><MapPin className="w-3.5 h-3.5 text-primary" /> Birmingham, United Kingdom</li>
              <li className="flex items-center gap-2 text-xs text-muted-foreground"><Globe className="w-3.5 h-3.5 text-primary" /> www.shopandship.com</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] text-muted-foreground">
            © {new Date().getFullYear()} SHOP & SHIP LTD. {isRTL ? 'جميع الحقوق محفوظة.' : 'All rights reserved.'}
            <span className="mx-2">|</span>
            Company No. 14860312
          </p>
          <div className="flex items-center gap-3">
            <img src="https://cryptologos.cc/logos/tether-usdt-logo.svg" alt="" className="h-4 opacity-40" />
            <img src="https://cryptologos.cc/logos/tron-trx-logo.svg" alt="" className="h-4 opacity-40" />
            <span className="text-[10px] text-muted-foreground/50">TRC-20 Payments</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
